<template>
  <button
    type="submit"
    class="w-full aha-button aha-button-primary-light aha-button-xl"
    @click.prevent="handleThirdPartyLogin"
  >
    <span
      class="icon"
    >
      <aha-icon
        maintain-color
        :name="iconProvider"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      />
    </span>
    <slot />
    <aha-spinner class="ml-2" variant="dark" v-if="submittingGG" />
  </button>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import constant from '@/constant'
import Util from '@/util'
import config from '@/config'
import { isTrialLink } from '@/utils/trial-plan.utils'

const isAuthFormVersion2 = true

export default {
  name: 'ThirdPartyButton',
  props: {
    type: {
      type: String,
      default: 'login',
    },
    provider: {
      type: String,
      default: 'google',
    },
  },
  data: () => {
    return {
      submittingGG: false,
      intervalTokenGoogleSlide: null,
    }
  },
  computed: {
    ...mapState({
      integrationPlatform: (state) => state.integrationPlatform,
    }),
    iconProvider() {
      return this.provider === 'google' ? 'gg' : 'microsoft'
    },
  },
  destroyed() {
    this.clearInterval()
  },
  methods: {
    ...mapActions([
      'setIsServerConnectableAction',
    ]),
    clearInterval() {
      if (this.intervalTokenGoogleSlide) {
        clearInterval(this.intervalTokenGoogleSlide)
        this.intervalTokenGoogleSlide = null
      }
    },
    handleTokenGoogleSlide() {
      this.clearInterval()
      this.intervalTokenGoogleSlide = window.setInterval(async () => {
        const code = window.localStorage.getItem('authAddOnData')
        if (code) {
          window.localStorage.removeItem('authAddOnData')
          const googleRedirect = config.googleSlideWebUrl
          const resp = await this.$http.post(config.api.googleSigninPPT, {
            code,
            redirectUri: googleRedirect,
          })
          Util.setCookieToken(resp.body.token)
          Object.assign(this.$http.headers, {
            common: { Authorization: `Bearer ${resp.body.token}` },
          })
          this.$router.push({ name: 'IntegrationGoogleSlide' })
          this.clearInterval()
        }
      }, 3000)
    },
    saveSessionData() {
      const {
        GOOGLE_SIGNIN_FROM,
        GOOGLE_SIGNIN_SOURCE,
        GOOGLE_SIGNIN_REDIRECT,
        GOOGLE_SIGNIN_SAVE_SPINNER_WHEEL,
        GOOGLE_SIGNIN_SAVE_WORDCLOUD,
      } = constant.storageKeys
      window.localStorage.setItem(GOOGLE_SIGNIN_FROM, this.type)
      window.localStorage.setItem(GOOGLE_SIGNIN_SOURCE, window.location.href)
      window.localStorage.setItem('isTrialLink', isTrialLink(window.location.href))
      const isBulkLicenseCheckout = Util.getParamValue('bl_checkout', window.location.href)
      if (isBulkLicenseCheckout) {
        const bulkLicenseCheckoutSessionData = {
          plan: Util.getParamValue('bl_plan', window.location.href),
          quantity: parseInt(Util.getParamValue('bl_qty', window.location.href), 10),
        }
        window.localStorage.setItem('bl_checkout', JSON.stringify(bulkLicenseCheckoutSessionData))
      }
      const redirect = Util.getParamValue('redirect', window.location.href)
      const spinnerwheel = Util.getParamValue('spinnerwheel', window.location.href)
      const wordcloud = Util.getParamValue('wordcloud', window.location.href)
      if (redirect) {
        window.localStorage.setItem(GOOGLE_SIGNIN_REDIRECT, redirect)
      }
      if (spinnerwheel) {
        window.localStorage.setItem(GOOGLE_SIGNIN_SAVE_SPINNER_WHEEL, wordcloud)
      }
      if (wordcloud) {
        window.localStorage.setItem(GOOGLE_SIGNIN_SAVE_WORDCLOUD, wordcloud)
      }
    },

    handleThirdPartyLogin() {
      this.submittingGG = true
      Util.mixpanelTracking(
        'Register',
        `Click ${this.type} button`,
        `with ${this.provider}`,
        null,
        {
          isAuthFormVersion2,
        },
      )

      this.saveSessionData()

      setTimeout(() => {
        this.submittingGG = false
        if (this.$store.state.isEnableAddinPowerpoint) {
          window.handleTokenApp = (token) => {
            Util.setCookieToken(token)
            setTimeout(() => {
              window.location.href = `${config.presenterDomain}/apps/presentations`
            }, 500)
          }
          window.open(`${config.presenterDomain}/google-redirect`, '', 'width=500, height=500')
          // this.$func.go(`${config.presenterDomain}/api/auth/google/?redirectUrl=${config.presenterDomain}/auth?provider=google`)
        } else if (this.integrationPlatform === 'GoogleSlide') {
          window.open(`${config.presenterDomain}/google-redirect?redirectUrl=${config.googleSlideWebUrl}`, 'popupWindow', 'width=500, height=500')
          this.handleTokenGoogleSlide()
        } else {
          let urlSignin = config.api.googleSignin
          if (this.provider === 'microsoft') {
            urlSignin = config.api.microsoftSignin
          }
          this.$func.go(urlSignin)
        }
      }, 1000) // give timeout to avoid cancel gaTracking
    },
  },
}
</script>

<style lang="scss" scoped>
button.aha-button {
  --tw-shadow: none !important;
  --tw-shadow: none !important;
  --tw-translate-y: 0 !important;
  padding: 0.5rem;

  .icon {
    position: absolute;
    left: 0.25rem;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
